"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemShade = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _jsxRuntime = require("react/jsx-runtime");
const ColorInfo = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'inline-grid',
  paddingLeft: theme.spacing(2),
  gridTemplateColumns: '10px 1fr',
  gap: theme.spacing(1),
  alignItems: 'center'
}));
const ColorVisual = (0, _mui.styled)(_presentationComponents.Shade)(() => ({
  display: 'inline-block',
  width: 10,
  height: 10,
  overflow: 'hidden'
}));
const ItemShade = ({
  code,
  itemTestId,
  shade
}) => {
  const theme = (0, _mui.useTheme)();
  const {
    hexColors,
    imageUrl,
    shadeName
  } = shade ?? {};
  if (!shadeName) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ColorInfo, {
    "data-testid": `${itemTestId}-shade`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ColorVisual, {
      shade: {
        canBeSold: true,
        hexColors,
        imageUrl,
        productCode: code,
        name: shadeName
      },
      size: _presentationComponents.ShadeSize.Small,
      testId: `${itemTestId}-shade-visual`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "caption",
      color: theme.palette.text.secondary,
      children: shadeName
    })]
  });
};
exports.ItemShade = ItemShade;
